import component from "./Reports";

export default component;
